import { ProductSearchViewModel } from '@models/api-search.models';

type Promotion = {
    promotion_id: string;
    promotion_name: string;
};

export const mapToPromotion = (splashes: ProductSearchViewModel['activeSplashes']): Promotion | undefined => {
    if (!splashes || !splashes.length) {
        return;
    }

    const [primary] = splashes
        .filter(splash => splash.isPrimary)
        .map(splash => ({ promotion_id: splash.id || '', promotion_name: splash.text || '' }));
    return primary;
};
